import React from "react";
import "../Ourclient.css";
import { Container } from "react-bootstrap";
import ReactReadMoreReadLess from "react-read-more-read-less";
import upwork from "../../../../Asset/ourclient/image-84.svg";
import clutch from "../../../../Asset/ourclient/Group.svg";
import envelop from "../../../../Asset/ourclient/Frame-290524.svg";
import stars from "../../../../Asset/ourclient/star.svg";
import firstImg from "../../../../Asset/ourclient/Matt-transformed-1.svg";
import secondImg from "../../../../Asset/ourclient/david.svg";
import thirdImg from "../../../../Asset/ourclient/florian-hellburg.svg";
import fourthImg from "../../../../Asset/ourclient/debbie-manchur.svg";
import fifthImg from "../../../../Asset/ourclient/trueman.svg";
import sixthImg from "../../../../Asset/ourclient/riley-mack.svg";

const testimonials = [
  {
    id: 1,
    img: firstImg,
    name: "Mathew Abar",
    position: "CEO of Finfolio",
    industry: "Financial Services",
    rating: "5/5",
    platform: upwork,
    review:
      "Codeffi Team did a great job for us over 2 full years. They have great attention to detail and built some amazing screens for our material design app. Highly recommended.",
  },
  {
    id: 2,
    img: secondImg,
    name: "David Scott",
    position: "COO at ShipTime Canada Inc. & Paid Inc.",
    industry: "SaaS",
    platform: envelop,
    review:
      "Wow, our new website is finally complete, and we couldn't be more thrilled! The entire process took just a month, thanks to the incredible teamwork and dedication from everyone involved. It was amazing to see how each team member brought their unique skills and enthusiasm to the table.",
  },
  {
    id: 3,
    img: thirdImg,
    name: "Florian Hellberg",
    position: "CTO of ProgressMaker",
    industry: "Enterprise Solution",
    rating: "5/5",
    platform: upwork,
    review:
      "The Angular coding and results have a very high standard. Excellent at solving requirements, dealing with complex frontend web applications and APIs, and understands the tasks very well.",
  },
  {
    id: 4,
    img: fourthImg,
    name: "Debbie Manchur",
    position: "Officer at Semiahmoo Yacht Club",
    industry: "Hospitality",
    rating: "5/5",
    platform: clutch,
    review:
      "I was recently involved in a project to add functionality to a website for a social club, built on WordPress. I had spoken to a few developers and chose to work with Codeffi. They are excellent to work with, very professional and produce quality results.",
  },
  {
    id: 5,
    img: fifthImg,
    name: "Michael Trueman",
    position: "Founder of Parcelport",
    industry: "Logistics",
    platform: envelop,
    review:
      "We have been working with Codeffi since the inception of our company four years ago and they have been instrumental in helping us build our core business applications. They have been great team players, working collaboratively to help turn our business requirements into working software solutions.",
  },
  {
    id: 6,
    img: sixthImg,
    name: "Riley Mack",
    position: "Design-Web Integrator at Tellwell Story Co",
    industry: "Ecommerce",
    rating: "5/5",
    platform: upwork,
    review:
      "I had the pleasure of collaborating with Codeffi on developing custom client-based e-commerce stores using WooCommerce integrated with our WordPress site. coddeffian's expertise in coding, particularly in WordPress and WooCommerce, was evident in the fantastic results she delivered.",
  },
];

const InnerTestimonial = () => {
  return (
    <section className="our-client-section inner-testimonial-section mt-5">
      <Container>
        <div className="top-text-ourclient">
          <h2>
            SUCCESS <span>STORIES</span>
          </h2>
        </div>
        <div className="testimonial_inner">
          <div className="row">
            {testimonials.map(
              ({
                id,
                img,
                name,
                position,
                industry,
                review,
                rating,
                platform,
              }) => (
                <div key={id} className="col-lg-6 col-md-6">
                  <div className="testimonial_boxs wide_box">
                    <div className="img_text_part">
                      <div className="img_part">
                        <img alt={`${name}`} src={img} />
                      </div>
                      <div className="text_part">
                        <h3>{name}</h3>
                        <p>{position}</p>
                      </div>
                    </div>
                    <div className="content_part">
                      <p className="content_p">
                        <ReactReadMoreReadLess
                          charLimit={200}
                          readMoreText={"Read more"}
                          readLessText={"Read less"}
                          readMoreClassName="read-more"
                          readLessClassName="read-more"
                        >
                          {review}
                        </ReactReadMoreReadLess>
                      </p>
                    </div>
                    <div className="bottom_part">
                      <div className="left">
                        <p>Industry</p>
                        <h6>{industry}</h6>
                      </div>
                      <div className="right">
                        <div className="upwork-img">
                          <img alt="platform-logo" src={platform} />
                        </div>
                        {rating && (
                          <div className="stars-part">
                            <img alt="stars" src={stars} />
                            <span>{rating}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default InnerTestimonial;
